'use client';

import { useFormContext, useWatch } from 'react-hook-form';

import { useDecisions } from '@libs/common-next';
import { getAutoshipCadenceByValue } from '@libs/common-types';

import { AutoshipFrequencySelect, getAutoshipFrequencyItems } from '../product-details';
import type { MiniPdpForm } from './types';

export function MiniPdpAutoshipFrequency() {
    const as_freq_5_7 = useDecisions('as_freq_5_7');
    const { setValue } = useFormContext<MiniPdpForm>();
    const [autoshipFrequency, autoshipUnit] = useWatch<MiniPdpForm, ['autoshipFrequency', 'autoshipUnit']>({
        name: ['autoshipFrequency', 'autoshipUnit'],
    });

    const handleChange = (value: string) => {
        const cadence = getAutoshipCadenceByValue(value);

        if (!cadence) return;

        setValue('autoshipFrequency', cadence.frequency, { shouldDirty: true, shouldValidate: true });
        setValue('autoshipUnit', cadence.unitOfMeasure, { shouldDirty: true, shouldValidate: true });
    };

    return (
        <AutoshipFrequencySelect
            items={getAutoshipFrequencyItems({ withOneTime: false, as_freq_5_7 })}
            value={`${autoshipFrequency}_${autoshipUnit}`}
            onChange={handleChange}
            testId="mini-pdp-autoship-frequency"
        />
    );
}
